"use client"

import React from "react"

import { ForceUpdateProviderProps } from "."

const ForceUpdateProvider = ({ children }: ForceUpdateProviderProps) => {
  return <>{children}</>
}

export default ForceUpdateProvider
